import ExcelJS from 'exceljs';
import { unfolder } from './CryptoMethods';
import { urlValue } from './url';
import axios from 'axios';

/* This solution works with the XLSX package */
/*export const onImportExcelAsync = (file) => {
    return new Promise((resolve, reject) => {
        // Obtener el objeto del archivo cargado
        const { files } = file.target;
        // Leer el archivo a través del objeto FileReader
        const fileReader = new FileReader();
        fileReader.onload = event => {

            const { result } = event.target;
            // Leer en secuencia binaria para obtener todo el objeto de tabla de Excel
            const workbook = XLSX.read(result, { type: 'binary' }); 
            let data = []; // almacena los datos obtenidos
            // recorre cada hoja de trabajo para leer (aquí solo se lee la primera tabla por defecto)
            for (const sheet in workbook.Sheets) {
                if (workbook.Sheets.hasOwnProperty(sheet)) {
                    // usa el método sheet_to_json para convertir Excel a datos json
                    data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                    // break; // Si solo se toma la primera tabla, descomenta esta línea
                }
            }
            console.log('data',data)
            //resolve(data);

            // Aquí puede lanzar una solicitud relacionada para un error de tipo de archivo incorrecto

        }
        fileReader.onerror = reject;
        // Abre el archivo en modo binario
        fileReader.readAsBinaryString(files[0]);
    })
}*/


/* This solution works with the ExcelJS package */
export const onImportExcelAsync = (file, headers = ['Name', 'Code', 'Type', 'Locale', 'Content', 'Technical_Text']) => {
  return new Promise((resolve, reject) => {
    const { files } = file.target;
    const fileReader = new FileReader();

    fileReader.onload = async (event) => {
      const { result } = event.target;
      const workbook = new ExcelJS.Workbook();

      try {
        await workbook.xlsx.load(result);

        let data = [];

        workbook.eachSheet((sheet) => {
          const sheetData = [];

          sheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
              const rowData = row.values.slice(1).reduce((acc, cell, index) => {
                acc[headers[index]] = cell !== undefined && cell !== null ? cell : '';
                return acc;
              }, {});

              if (Object.values(rowData).some(value => value !== '')) {
                sheetData.push(rowData);
              }
            }
          });

          data = data.concat(sheetData);
        });
        console.log('data', data)
        resolve(data);
      } catch (error) {
        reject(error);
      }
    };

    fileReader.onerror = reject;
    fileReader.readAsArrayBuffer(files[0]);
  });
};

const getHeader = async (name) => {
  let data = [];
  if (name == 'FormatUsers.xlsx') {
    data = [
      { header: 'CCMS_ID', key: 'ccms_id', width: 15 },
      { header: 'CCMS_NAME', key: 'ccms_name', width: 20 },
      { header: 'GENDER', key: 'gender', width: 10 },
      { header: 'WAVE', key: 'wave', width: 10 }
    ]
  }
  else if (name == 'FormatAnswers.xlsx') {
    data = [
      { header: 'Code', key: 'code', width: 25 },
      { header: 'Name', key: 'name', width: 20 },
      { header: 'Type', key: 'type', width: 10 },
      { header: 'Content', key: 'content', width: 20 },
      { header: 'Technical_Text', key: 'technicaltext', width: 20 },
      { header: 'Locale', key: 'locale', width: 20 }
    ]
    // example: ['ANS001', 'Example Answer', '1', 'This is an example answer content', 'Technical details here', 'es-ES']
  }
  else if (name == 'FormatIntents.xlsx') {
    data = [
      { header: 'Code', key: 'code', width: 25 },
      { header: 'Name', key: 'name', width: 20 },
      { header: 'Description', key: 'description', width: 50 },
      { header: 'Examples', key: 'examples', width: 20 },
      { header: 'Answer', key: 'answer', width: 20 },
      { header: 'Language', key: 'language', width: 10 }
    ]
    // example: ['INT001', 'Example Intent', 'Description of the intent', 'Example 1; Example 2; Example 3', 'ANS001', 'es-ES']
  }
  else if (name == 'FormatProjects.xlsx') {
    data = [
      { header: 'Code', key: 'code', width: 25 },
      { header: 'Name', key: 'name', width: 20 },
      { header: 'Description', key: 'description', width: 50 },
      { header: 'Type', key: 'type', width: 20 },
      { header: 'Status', key: 'status', width: 20 }
    ]
    // example: ['PRJ001', 'Example Project', 'Project description', '1', 'Active']
  }
  else if (name == 'FormatUsersStudio.xlsx'){
    data = [
      { header: 'BMS', key: 'bms', width: 15 },
      { header: 'NT_USER', key: 'ntuser', width: 20 },
      { header: 'First_Name', key: 'firstname', width: 40 },
      { header: 'Lastname', key: 'lastname', width: 40 },
      { header: 'Role', key: 'role', width: 40 }
    ]
  }
  return data

}

const getExample = async (name, typeData) => {

  let data = [];
  if (name == 'FormatUsers.xlsx') {
    data = [
      { ccms_id: '2020202', ccms_name: 'ntuser.29', gender: 'male', wave: '20' },
      { ccms_id: '2020203', ccms_name: 'ntuser.30', gender: 'female', wave: 'namewave' },
    ]
  }
  else if (name == 'FormatAnswers.xlsx') {
    data = [
      { code: 'ANS001', name: 'Example Answer', type: '1', content: 'This is an example answer content', technicaltext: 'Technical details here', locale: 'es-ES' },
    ]
  }
  else if (name == 'FormatIntents.xlsx') {
    data = [
      { code: 'INT001', name: 'Example Intent', description: 'Description of the intent', examples: 'Example 1; Example 2; Example 3', answer: 'ANS001', language: 'es-ES' },
    ]
  }
  else if (name == 'FormatProjects.xlsx') {
    data = [
      { code: 'PRJ001', name: 'Example Project', description: 'Project description', type: '1', status: 'Active' },
    ]
  }
  else if (name == 'FormatUsersStudio.xlsx'){
    data = [
      { bms: '2020202', ntuser: 'ntuser.29', firstname: 'name', lastname: 'lastname', role: 'reader' },
      { bms: '2020203', ntuser: 'ntuser.30', firstname: 'name', lastname: 'lastname', role: 'admin' },
    ]
  }
  return data
}

export const onImportExcelExtendedCompatibility = (fileOrEvent) => {
  return new Promise((resolve, reject) => {
    // Con esto manejo tanto archivo directo como event.target.files
    let file;
    if (fileOrEvent.target && fileOrEvent.target.files) {
      file = fileOrEvent.target.files[0];
    } else {
      file = fileOrEvent;
    }

    if (!file) {
      reject(new Error('No se proporcionó ningún archivo'));
      return;
    }

    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel' // .xls
    ];

    if (!validTypes.includes(file.type)) {
      reject(new Error(`Invalid file type: ${file.type}. Please upload an Excel file.`));
      return;
    }

    const fileReader = new FileReader();

    fileReader.onload = async (event) => {
      try {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(event.target.result);

        const worksheet = workbook.getWorksheet(1);

        if (!worksheet) {
          reject(new Error('El archivo Excel no contiene hojas de cálculo'));
          return;
        }

        const headerRow = worksheet.getRow(1);
        const headers = [];

        headerRow.eachCell((cell) => {
          headers.push(cell.value ? cell.value.toString().trim() : '');
        });

        if (!headers.includes('CCMS_ID') || !headers.includes('CCMS_NAME')) {
          reject(new Error('El archivo debe contener las columnas CCMS_ID y CCMS_NAME'));
          return;
        }

        const data = [];

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            const rowData = {};
            let hasValues = false;

            row.eachCell((cell, colNumber) => {
              if (colNumber <= headers.length) {
                const header = headers[colNumber - 1];
                const value = cell.value;

                if (value !== null && value !== undefined) {
                  rowData[header] = value.toString().trim();
                  hasValues = true;
                } else {
                  rowData[header] = '';
                }
              }
            });

            headers.forEach(header => {
              if (rowData[header] === undefined) {
                rowData[header] = '';
              }
            });

            if (hasValues) {
              data.push(rowData);
            }
          }
        });

        resolve(data);
      } catch (error) {
        console.error('Error parsing Excel:', error);
        reject(new Error(`Error processing Excel file: ${error.message}`));
      }
    };

    fileReader.onerror = (error) => {
      console.error('FileReader Error:', error);
      reject(new Error('Error reading file'));
    };

    fileReader.readAsArrayBuffer(file);
  });
};

export const downloadFile = (name) => {
  let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
  let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
  axios({
    method: 'get',
    responseType: 'blob',
    url: `${urlValue}/studio/dw-file/${name}`,
    headers: {
      'user': id,
      'access-token': token,
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  }).then(function (response) {
    const data = response.data;

    const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // var url = window.URL.createObjectURL(data);
    // let tempLink = document.createElement('a');
    // tempLink.href = url;
    // tempLink.setAttribute('download', name);
    // tempLink.click();

  })

}

export const downloadFileFromFolder = (name) => {
  let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
  let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
  axios({
    method: 'get',
    responseType: 'blob',
    url: `${urlValue}/studio/download-file/${name}`,
    headers: {
      'user': id,
      'access-token': token,
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  }).then(function (response) {
    const data = response.data;
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
  });
}

export const downloadFileNew = async (name) => {
  try {
    // Crear un nuevo libro de Excel
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Users');

    // Definir columnas del Excel
    worksheet.columns = await getHeader(name);

    // Datos de ejemplo — Puedes reemplazarlos con tu data real
    const data = await getExample(name);

    // Agregar filas al Excel
    data.forEach((item) => worksheet.addRow(item));

    // Estilizar encabezado
    worksheet.getRow(1).font = { bold: true, color: { argb: 'FF0000FF' } }; // Azul

    // Generar el archivo Excel en un Blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Crear un enlace para descargar el archivo
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generando el archivo:', error);
  }

}